import Icon from "@/components/ui/icon";
import { AmenityEntity } from "@/features/private-room/list/adapters/get-privateroom/get-privateroom.types";
import {
  getTextToBadge,
  getTextToDescription,
} from "@/features/vision-360/components/get-icons";

const AmenityDetails = ({ amenity }: { amenity: AmenityEntity }) => {
  return (
    <div className="absolute bg-white border p-3 shadow-lg rounded bottom-4 right-[-100px] min-w-[150px]">
      {amenity.is_automatic_generated ? (
        <div className="relative flex items-center">
          <Icon name="Sparkles" style={{ marginRight: 4 }} />
          <p className="w-100 whitespace-nowrap">Gerado por IA</p>
        </div>
      ) : (
        amenity.attributes.length > 0 && (
          <div className="p-2">
            <h4 className="font-bold mb-2">{amenity.name}</h4>
            <ul>
              {amenity.attributes.map((attr, index) => (
                <li
                  key={index}
                  className="flex flex-row justify-start items-center"
                >
                  <p className="whitespace-nowrap mr-2 min-w-[50px]">
                    {getTextToDescription(attr.name)}
                  </p>
                  <div className="flex m-1 p-2 border rounded-md min-w-[150px] opacity-60">
                    <p className="whitespace-nowrap">
                      {getTextToBadge(attr).text}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )
      )}
    </div>
  );
};

export default AmenityDetails;
